import functions from "./functions.js";

const RECAPTCHA_KEY = '6LeAz5gUAAAAAKoZP6-NVwB5wTFGjyeCVGmm582z';

$(function () {

    const $form = $('.newsletter-form');

    if (!$form.length) return;

    const $btn     = $form.find('[type="submit"]');
    const $message = $form.find('.done-message');

    function setLoading(loading) {
        $form.toggleClass('processing', loading);
        if (loading) {
            $btn.prop('disabled', true)
                .data('label', $btn.html())
                .html('<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>');
        } else {
            $btn.prop('disabled', false).html($btn.data('label'));
        }
    }

    function handleResponse(response) {
        $form.addClass('done');
        $message.html(response.data).removeClass('d-none');

        setTimeout(() => {
            $form.removeClass('done');
            $message.html('').addClass('d-none');
        }, 4000);

        if (response.status === true) {
            $form[0].reset();
        }
    }

    async function onSubmit(e) {
        e.preventDefault();
        setLoading(true);

        const params = {};
        $.each($form.serializeArray(), (_, field) => {
            params[field.name] = field.value;
        });
        params.language = functions.getLang();

        try {
            const token = await new Promise(resolve =>
                grecaptcha.ready(() =>
                    grecaptcha.execute(RECAPTCHA_KEY, { action: 'contact' }).then(resolve)
                )
            );

            params.gRecaptchaToken = token;
            const raw = await $.post('/services/mailchimp/', functions.getDataForUrl(params));
            handleResponse(JSON.parse(raw));
        } catch (err) {
            console.error('[Newsletter]', err);
            $message.html('An error occurred. Please try again.').removeClass('d-none');
        } finally {
            setLoading(false);
        }
    }

    $form.on('submit', onSubmit);
});
